import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  Box,
  Typography,
  IconButton,
  Grid,
  CircularProgress,
  Button,
} from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { Link } from "react-router-dom";
import { useQuery, useLazyQuery } from "@apollo/client";
import * as Icons from "@material-ui/icons";

import { CustomSlider } from "../partials/slider";
import { PageTitle } from "../partials/pageTitle";
import { PreparationNeededModal } from "../partials/preparationNeededModal";
import { SearchBar } from "../partials/searchBar";

import { GET_INDUSTRY_LIST, SEARCH_OCCUPATION } from "../_redux/dashboardCrud";

// Sub Components

import store from "../../../../redux/store";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 180,
  },
});

export function IndustryList() {
  const classes = useStyles();

  function getHighlightedText(sourceString) {
    const charCount = 90;
    const reg = new RegExp(`.{1,${charCount}}`, "g");
    const arr = sourceString.match(reg);
    const searchReg = new RegExp(`${searchValue}`, "i");
    if (!searchValue.length || !searchReg.test(sourceString)) {
      return (
        <Typography>
          <b>{sourceString}</b>
        </Typography>
      );
    }
    for (const [i, dividedString] of arr.entries()) {
      if (searchReg.test(dividedString)) {
        const temp = searchReg.exec(dividedString);
        const tempstr = dividedString.slice(
          temp.index,
          temp.index + temp[0].length
        );

        if (dividedString.length < 80) {
          return (
            <Typography>
              <b>
                Also known as: ...
                {arr[i - 1]
                  ? arr[i - 1].slice(50)
                  : "" + dividedString.slice(0, temp.index)}{" "}
                <span style={{ backgroundColor: "yellow" }}>{tempstr}</span>{" "}
                {dividedString.slice(temp.index + temp[0].length)}...
              </b>
            </Typography>
          );
        }
        return (
          <Typography>
            <b>
              Also known as: ...{dividedString.slice(0, temp.index)}{" "}
              <span style={{ backgroundColor: "yellow" }}>{tempstr}</span>{" "}
              {dividedString.slice(temp.index + temp[0].length)}...
            </b>
          </Typography>
        );
      }
    }
  }

  function getHighlightedTextInTitle(title) {
    const searchReg = new RegExp(`${searchValue}`, "i");
    if (!searchValue.length || !searchReg.test(title)) {
      return title;
    }
    if (searchReg.test(title)) {
      const temp = searchReg.exec(title);
      return (
        <span>
          {title.slice(0, temp.index)}
          <span style={{ backgroundColor: "yellow" }}>
            <b> {title.slice(temp.index, temp.index + temp[0].length)}</b>
          </span>
          {title.slice(temp.index + temp[0].length)}
        </span>
      );
    } else {
      return title;
    }
  }

  const { data, loading } = useQuery(GET_INDUSTRY_LIST, {
    fetchPolicy: "cache-first",
  });

  useEffect(()=>{
    console.log(data, 'yes data');
  }, [data])
  const columns = [
    {
      field: "title",
      headerName: "Occupation",
      width: 800,
      renderCell: (params) => {
        return (
          <Box>
            <Box>
              <Typography
                color="secondary"
                // onClick={() => {
                //   history.push(
                //     `/occupation/${params.row.blsIndustryId}/${params.row.occupationId}`
                //   );
                // }}
                style={{ cursor: "pointer" }}
              >
                {" "}
                <Link
                  to={`/occupation/${params.row.blsIndustryId}/${params.row.occupationId}`}
                >
                  {getHighlightedTextInTitle(params.value)}
                </Link>
              </Typography>
              {getHighlightedText(params.row.jobTitleSamples.join(", "))}
            </Box>
            {/* <Box></Box> */}
          </Box>
        );
      },
    },
    {
      field: "jobZoneId",
      headerName: "Preparation",
      width: 100,
      renderCell: (params) => {
        if (!params.value) {
          return "N/A";
        }
        return (
          <img
            width={30}
            height={25}
            src={getPreparationImageSrc(params.value)}
            alt={params.value}
          />
        );
      },
    },
    {
      field: "occupationBlsValue",
      headerName: "Annual Median Wage",
      width: 180,
      renderCell: (params) => {
        if (!params.value) {
          return "N/A";
        }
        return "$" + params.value;
      },
    },
  ];

  const [searchOccupations, { loading: searchLoading }] = useLazyQuery(
    SEARCH_OCCUPATION,
    {
      fetchPolicy: "cache-first",
      onCompleted: (data) => {
        prepareData(data.searchOccupation);
      },
    }
  );

  const {
    auth: { tokenExpiresAt },
  } = store.getState();
  if (moment().isAfter(moment(tokenExpiresAt))) {
    localStorage.clear();
  }

  const [occupationForIndustries, setSearchedOccupations] = useState([]);

  function prepareData(searchOccupation) {
    let res = [];
    searchOccupation.industryList.forEach((industry) => {
      let occupationsForIndustry = [];
      let filteredIndustryOccupationMap = _.filter(
        searchOccupation.industryOccupationMap,
        {
          blsIndustryId: industry.blsIndustryId,
        }
      );
      const blsOccupationIds = filteredIndustryOccupationMap.map(
        (m) => m.blsOccupationId
      );
      for (const blsOccupationId of blsOccupationIds) {
        const blsData = _.find(searchOccupation.occupationBlsSeriesMap, {
          blsOccupationId,
          blsIndustryId: industry.blsIndustryId,
        });
        const occupationBlsValue = blsData ? blsData.value : "N/A";

        // _.max(
        //   _.filter(searchOccupation.occupationBlsSeriesMap, {
        //     occupationId: occupation.occupationId,
        //   }).map((occupation) => occupation.blsSeries.value)
        // );
        occupationsForIndustry.push({
          ..._.find(searchOccupation.occupations, {
            blsOccupationId: blsOccupationId,
          }),
          occupationBlsValue,
          id: blsOccupationId,
          blsIndustryId: industry.blsIndustryId,
        });
      }

      res.push({
        id: industry.blsIndustryId,
        title: industry.title,
        occupations: occupationsForIndustry,
      });
    });
    setSearchedOccupations(res);
  }

  const [searchValue, setSearchValue] = useState("");
  const [minimumWageValue, setMinimumWageValue] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const onSearch = (text) => {
    setSearchValue(text);
    if (!isFilterApplied) {
      setIsFilterApplied(true);
    }
    setSearchedOccupations([]);
    searchOccupations({
      variables: {
        searchOccupationSearch: text,
        searchOccupationPreparationNeeded: preparationLevel,
        minAnnualWage: minimumWageValue,
      },
    });
  };

  function getPreparationImageSrc(level) {
    switch (level) {
      case 1:
        return "/media/svg/preparation-needed/1.svg";
      case 2:
        return "/media/svg/preparation-needed/2.svg";
      case 3:
        return "/media/svg/preparation-needed/3.svg";
      case 4:
        return "/media/svg/preparation-needed/4.svg";
      case 5:
        return "/media/svg/preparation-needed/5.svg";

      default:
        return "";
    }
  }

  function getImageSrc(industryId) {
    switch (industryId) {
      case "71--72":
        return "/media/icons/arts.png";

      case "000000":
        return "/media/icons/government.png";

      case "61--62":
        return "/media/icons/education.png";

      case "62--63":
        return "/media/icons/health.png";

      case "48--50":
        return "/media/icons/transportation.png";

      case "52--53":
        return "/media/icons/finance.png";

      case "55--56":
        return "/media/icons/management.png";

      case "72--73":
        return "/media/icons/accomodation.png";

      case "23--24":
        return "/media/icons/construction.png";

      case "11--12":
        return "/media/icons/farming.png";

      case "31--34":
        return "/media/icons/manufacturing.png";

      case "81--82":
        return "/media/icons/service.png";

      case "22--23":
        return "/media/icons/utilities.png";

      case "21--22":
        return "/media/icons/mining.png";

      case "42--43":
        return "/media/icons/wholesale.png";

      case "44--46":
        return "/media/icons/retail.png";

      case "54--55":
        return "/media/icons/science.png";

      case "53--54":
        return "/media/icons/realEstate.png";

      case "56--57":
        return "/media/icons/support.png";

      case "51--52":
        return "/media/icons/information.png";

      default:
        return "";
    }
  }

  const [preparationLevel, setPreparationLevel] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [resetSlider, setResetSlider] = useState(false);

  function changePreparationLevel(level) {
    if (!isFilterApplied) {
      setIsFilterApplied(true);
    }
    let levels = [];
    levels = preparationLevel;
    if (preparationLevel.includes(level)) {
      levels.splice(levels.indexOf(level), 1);
    } else {
      levels.push(level);
    }
    setPreparationLevel(levels);
    searchOccupations({
      variables: {
        searchOccupationSearch: searchValue,
        searchOccupationPreparationNeeded: levels,
        searchOccupationMinAnnualWage: minimumWageValue,
      },
    });
  }

  const handleSliderChange = (event, newValue) => {
    setResetSlider(false);
    if (!isFilterApplied) {
      setIsFilterApplied(true);
    }
    searchOccupations({
      variables: {
        searchOccupationSearch: searchValue,
        searchOccupationPreparationNeeded: preparationLevel,
        searchOccupationMinAnnualWage: newValue,
      },
    });
    setMinimumWageValue(newValue);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      style={{ backgroundColor: "white" }}
      px={2}
    >
      <PageTitle></PageTitle>
      <Box my={2} width="100%">
        <SearchBar onSearch={onSearch} />
      </Box>
      <Box display="flex" alignItems="center">
        <Typography variant="h5">Preparation needed</Typography>
        <Box>
          <IconButton
            aria-label="info"
            onClick={() => {
              setModalOpen(true);
            }}
          >
            <Icons.InfoRounded />
          </IconButton>
          <PreparationNeededModal
            open={modalOpen}
            onClose={() => {
              setModalOpen(false);
            }}
          />
        </Box>
      </Box>
      <Box display="flex">
        <IconButton
          onClick={() => {
            changePreparationLevel(1);
          }}
        >
          <Icons.LooksOne
            style={
              preparationLevel.includes(1)
                ? { color: "#01a9f4" }
                : { color: "#918d8d" }
            }
            fontSize="large"
          />
        </IconButton>
        <IconButton
          onClick={() => {
            changePreparationLevel(2);
          }}
        >
          <Icons.LooksTwo
            style={
              preparationLevel.includes(2)
                ? { color: "#01a9f4" }
                : { color: "#918d8d" }
            }
            fontSize="large"
          />
        </IconButton>
        <IconButton
          onClick={() => {
            changePreparationLevel(3);
          }}
        >
          <Icons.Looks3
            style={
              preparationLevel.includes(3)
                ? { color: "#01a9f4" }
                : { color: "#918d8d" }
            }
            fontSize="large"
          />
        </IconButton>
        <IconButton
          onClick={() => {
            changePreparationLevel(4);
          }}
        >
          <Icons.Looks4
            style={
              preparationLevel.includes(4)
                ? { color: "#01a9f4" }
                : { color: "#918d8d" }
            }
            fontSize="large"
          />
        </IconButton>
        <IconButton
          onClick={() => {
            changePreparationLevel(5);
          }}
        >
          <Icons.Looks5
            style={
              preparationLevel.includes(5)
                ? { color: "#01a9f4" }
                : { color: "#918d8d" }
            }
            fontSize="large"
          />
        </IconButton>
      </Box>
      <Box display="flex" width="60%" mt={2}>
        <Icons.MonetizationOn fontSize="large" style={{ color: "#01a9f4" }} />
        <CustomSlider
          reset={resetSlider}
          valueLabelDisplay="on"
          aria-label="pretto slider"
          onChange={handleSliderChange}
          min={10000}
          max={175000}
          step={10000}
        />
      </Box>
      {isFilterApplied && (
        <Box m={3}>
          <Button
            onClick={() => {
              setResetSlider(true);
              setPreparationLevel([]);
              setSearchValue("");
              setIsFilterApplied(false);
            }}
          >
            <Icons.Clear />
            CLEAR FILTERS
          </Button>
        </Box>
      )}
      {isFilterApplied &&
        (searchLoading ? (
          <CircularProgress style={{ color: "#3699FF" }} />
        ) : (
          occupationForIndustries.map((industry) => (
            <Box width="100%" mt={3} key={industry.id}>
              <Box className={classes.root} boxShadow={5}>
                <Grid container justify="space-between" alignItems="center">
                  <Grid item xs={12} md={2}>
                    <Link to={`industry/${industry.id}`}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        m={2}
                        alignItems="center"
                        justifyContent="space-between"
                        width={200}
                        style={{ cursor: "pointer" }}
                      >
                        <Box>
                          <img
                            width={80}
                            height={80}
                            src={getImageSrc(industry.id)}
                            alt={industry.title + " image"}
                          />
                        </Box>
                        <Box
                          width="80%"
                          textAlign="center"
                          mt={2}
                          pb={1}
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                        >
                          <Typography
                            variant="subtitle2"
                            style={{ color: "#01a9f4" }}
                          >
                            {industry.title}
                          </Typography>
                          <Box
                            flexGrow={1}
                            height={3}
                            width="70%"
                            style={{ backgroundColor: "#01a9f4" }}
                            mt={1}
                          ></Box>
                        </Box>
                      </Box>
                    </Link>
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <Box textAlign="center" height={250} p={2}>
                      <DataGrid
                        hideFooter
                        hideFooterPagination
                        rows={industry.occupations}
                        columns={columns}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          ))
        ))}
      {!isFilterApplied && (
        <Box
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          justifyContent="center"
          mt={3}
        >
          {loading ? (
            <CircularProgress style={{ color: "#3699FF" }} />
          ) : (
            data && data.industryList && data.industryList.map((e) => (
              <Link to={`industry/${e.blsIndustryId}`} key={e.blsIndustryId}>
                <Box
                  display="flex"
                  flexDirection="column"
                  m={2}
                  alignItems="center"
                  justifyContent="space-between"
                  width={250}
                  key={e.blsIndustryId}
                  style={{ cursor: "pointer" }}
                >
                  <Box>
                    <img
                      src={getImageSrc(e.blsIndustryId)}
                      alt={
                        getImageSrc(e.blsIndustryId).split("/")[
                          getImageSrc(e.blsIndustryId).split("/").length - 1
                        ]
                      }
                    />
                  </Box>
                  <Box
                    width="80%"
                    textAlign="center"
                    mt={2}
                    pb={1}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Typography
                      variant="subtitle2"
                      style={{ color: "#01a9f4" }}
                    >
                      {e.title}
                    </Typography>
                    <Box
                      flexGrow={1}
                      height={3}
                      width="70%"
                      style={{ backgroundColor: "#01a9f4" }}
                      mt={1}
                    ></Box>
                  </Box>
                </Box>
              </Link>
            ))
          )}
        </Box>
      )}
    </Box>
  );
}
